import { takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import {
    prismApiFetchSuccess,
    prismApiFetchFailed,
    prismApiFetchCustomLoginSuccess,
    getV4APIsAction,
} from '../actions';
import {
    GET_WELCOME_BANNER,
    GET_PRISM_VERSION,
    GET_PRISM_LOGIN_CUSTOM,
    GET_PROVIDERS_LIST,
} from '../constants';
import { logger } from './../utils';
import { fetchPrismVersion } from '../api/system-config-api';

/**
 * fetch system configuration saga
 * handles fetch for system configuration and dispatches display of welcome banner
 * if response has isEnabled = true or dispatches getConnectors actions
 * if isEnabled = false
 * @param {Object} payload - payload for the worker
 * @returns {void}
 */
function* fetchSystemConfigRequest(payload) {
    yield put(
        getV4APIsAction({
            name: GET_WELCOME_BANNER,
            options: {},
        })
    );

    // Make sure GET_PROVIDERS always called after get welcome content
    yield put(
        getV4APIsAction({
            name: GET_PROVIDERS_LIST,
            options: {
                $orderby: 'name',
                $filter: 'isBrowserLoginSupported eq true',
            },
        })
    );
}

const DEFAULT_VERSION = 'euphrates-5.19-stable-pc-0';

/**
 * fetch prism prelogin details saga
 * handles fetch for prism prelogin details and get software version
 * dispatches display of help link
 * @param {Object} payload - payload for the worker
 * @returns {void}
 */
function* fetchPrismVersionRequest(payload) {
    try {
        const { name } = payload.request;
        const response = yield call(fetchPrismVersion, payload.request);
        if (response[name]) {
            const { version } = response[name];
            yield put(
                prismApiFetchSuccess({
                    endpoint: payload.type,
                    json: version,
                })
            );
        }
        // If PrismAPI fetch success, get other action dispatch
        if (response && response.customLogin) {
            yield put(
                prismApiFetchCustomLoginSuccess({
                    endpoint: GET_PRISM_LOGIN_CUSTOM,
                    json: response.customLogin,
                })
            );
        }
    } catch (error) {
        logger('systemConfigSaga', error);
        yield put(
            prismApiFetchFailed({
                endpoint: payload.type,
                json: DEFAULT_VERSION,
            })
        );
    }
}

/**
 *  getSystemComfig watcher
 * @returns {void}
 */
export function* watchGetSystemConfig() {
    yield takeLatest(GET_WELCOME_BANNER, fetchSystemConfigRequest);
}

/**
 *  getPrismVersion watcher
 *  @returns {void}
 */
export function* watchGetPrismVersion() {
    yield takeLatest(GET_PRISM_VERSION, fetchPrismVersionRequest);
    // yield takeLatest(GET_PRISM_LOGIN_CUSTOM, fetchPrismVersionRequest);
}
